import { Outlet } from 'react-router-dom'
import { Sidebar } from './ui/Sidebar'
import { Header } from './ui/Header'

export const SidebarMenuLayout = () => {
  return (
    <div className={'relative flex h-full min-h-0 flex-1 flex-col bg-[#F8FAFE] md:flex-row'}>
      <div className={'-mb-[12px] bg-focus-500 pb-[12px] md:hidden'}>
        <Header />
      </div>
      <div className={'z-20 hidden md:block'}>
        <Sidebar />
      </div>
      <div className={'relative z-10 min-h-0 min-w-0 flex-1'}>
        {/* на экранах с таблицей низ занимает строка пагинации со своей высотой — отступ обёртки снизу не нужен */}
        <div
          className={
            'flex h-full w-full flex-col overflow-y-auto rounded-t-[12px] bg-white p-[16px] shadow-depth-100 shadow-focus-500/[0.05] md:rounded-none xl:p-[20px] [&:has([data-table-pagination])]:pb-0'
          }
        >
          <Outlet />
        </div>
      </div>
    </div>
  )
}
